import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './ConfigFacturacion.scss';
import DataGrid, { Editing, Item, Scrolling, SearchPanel, Sorting, Toolbar, Selection, Column, Form, Popup, Button as Butt, Pager } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { useApiConfiguration } from '../../api/api.configuration';
import { Button, Tooltip } from 'devextreme-react';
import { Item as ItemForm } from 'devextreme-react/form';
import { FacturacionContratos } from '../../types/types.facturacion';
import { ModalTarifas } from './Modals/ModalTarifas';
import { ModalConfirmation, newToast } from '../../components';

export default () => {
  const dataGridRef = useRef<DataGrid>(null);
  const { getContratos, newContrato, updateContrato, deleteContrato, cloneContrato, getClientes } = useApiConfiguration();
  const [selectedRow, setSelectedRow] = useState<FacturacionContratos>();
  const [modalvisible, setModalVisible] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const [clientes, setClientes] = useState<any[]>([]);

  useEffect(() => {
    getClientes()
      .then((res) => {
        setClientes(res);
      })
      .catch(() => {
        newToast('ERROR', 'Error al cargar los clientes', 5);
      });
  }, []);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Cn_Id',
      load() {
        return getContratos()
          .then((res) => ({
            data: res,
            totalCount: res.totalCount,
            summary: res.summary,
            groupCount: res.groupCount,
          }))
          .catch(() => {
            throw new Error('Error de carga de datos');
          });
      },
      insert: async (values) => {
        return newContrato(values)
          .then((res) => {
            if (res === 105) {
              dataGridRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el analito');
          });
      },
      update: (key, values) => {
        return updateContrato(key, values)
          .then((res) => {
            if (res === 107) {
              dataGridRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error actualizando el analito');
          });
      },
      remove: (key) => {
        return deleteContrato(key).then((res) => {
          if (res) {
            dataGridRef.current?.instance.refresh();
          }
        });
      },
    });
  }, []);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  const handleSelection = (e: any) => {
    const data = e.selectedRowsData[0];
    if (data) {
      // Do something
    }
  };

  const handleUpdateData = useCallback(() => {
    dataGridRef?.current?.instance.refresh();
  }, []);

  const handleTarifasClick = useCallback(
    (e) => {
      setSelectedRow(e.row.data);
      setModalVisible(true);
    },
    [setSelectedRow, setModalVisible]
  );

  const handleCloseModal = useCallback(() => {
    setModalVisible(false);
    setSelectedRow(undefined);
  }, [setModalVisible, setSelectedRow]);

  const handleClonarClick = useCallback(
    (e) => {
      setSelectedRow(e.row.data);
      setModalConfirmation(true);
    },
    [setModalConfirmation, setSelectedRow]
  );

  const handleClonarConfirm = useCallback(() => {
    if (!selectedRow) return;
    cloneContrato(selectedRow.Cn_Id).finally(() => {
      setModalConfirmation(false);
      setSelectedRow(undefined);
      dataGridRef.current?.instance.refresh();
    });
  }, [setModalConfirmation, setSelectedRow, selectedRow]);

  const handleClonarCancel = useCallback(() => {
    setModalConfirmation(false);
    setSelectedRow(undefined);
  }, [setModalConfirmation]);

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper view-wrapper-contact-list'>
        <DataGrid className='grid' dataSource={customDataSrc} ref={dataGridRef} hoverStateEnabled={true} width={'100%'} height='auto' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true} onSelectionChanged={handleSelection}>
          <SearchPanel visible={true} />
          <Scrolling columnRenderingMode='virtual' />
          <Sorting mode='multiple' />
          <Selection mode='single' />
          <Pager allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Editing mode='popup' allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true} texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar', addRow: 'Agregar' }}>
            <Popup title='Contrato' showTitle={true} width={700} height={525} />
            <Form>
              <ItemForm dataField='Cn_Cl_Id' label={{ text: 'Cliente' }} colSpan={2} editorType='dxSelectBox' editorOptions={{ items: clientes, displayExpr: 'Cl_Nombre', valueExpr: 'Cl_Id', searchEnabled: true }} />
              <ItemForm dataField='Cn_Nombre' label={{ text: 'Nombre contrato' }} colSpan={2} />
              <ItemForm dataField='Cn_Descripcion' label={{ text: 'Descripción' }} colSpan={2} editorType='dxTextArea' editorOptions={{ height: 200 }} />
              <ItemForm dataField='Cn_Estado' />
            </Form>
          </Editing>
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Contratos</div>
            </Item>
            <Item name='searchPanel' />
            <Item name='addRowButton' />
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Button id='RefrecarResult' icon='refresh' text='Refresh' stylingMode='text' onClick={handleUpdateData} />
              <Tooltip target={'#RefrecarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                Refrescar datos
              </Tooltip>
            </Item>
          </Toolbar>
          <Column dataField='Cn_Id' caption='ID' width={100} alignment='center' />
          <Column dataField='Cn_Cl_Id' caption='CLIENTE' width={200} lookup={{ dataSource: clientes, valueExpr: 'Cl_Id', displayExpr: 'Cl_Nombre' }} />
          <Column dataField='Cn_Nombre' caption='NOMBRE' width={200} />
          <Column dataField='Cn_Descripcion' caption='DESCRIPCIÓN' />
          <Column dataField='Cn_Estado' caption='ESTADO' dataType='boolean' width={100} alignment='center' />
          <Column type='buttons' caption={'ACCIÓN'} width={200}>
            <Butt name='edit' />
            <Butt name='delete' />
            <Butt hint='Tarifas' icon='money' visible={true} disabled={false} onClick={handleTarifasClick} />
            <Butt hint='Clonar tarifa' icon='copy' visible={true} disabled={false} onClick={handleClonarClick} />
          </Column>
        </DataGrid>
      </div>
      {selectedRow && <ModalTarifas visible={modalvisible} setVisible={handleCloseModal} Id={selectedRow.Cn_Id} />}
      {selectedRow && <ModalConfirmation message={`Seguro que desea clonar la tarifa '${selectedRow?.Cn_Nombre}'`} visible={modalConfirmation} onConfirm={handleClonarConfirm} onCancel={handleClonarCancel} />}
    </div>
  );
};
